module.exports = __webpack_public_path__ + "media/images/front/products/standard/product_4-a542f1b7508eb191f76ff3056a5bc748.jpg";